export enum ReferenceType {
    DEPARTMENT='DEPARTMENT',
    PURPOSE='PURPOSE',
    ROLE='ROLE',
    STATUS='STATUS'
}
